import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18.707 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1 -1.414 0l-6 -6a1 1 0 0 1 1.414 -1.414l5.293 5.293l5.293 -5.293a1 1 0 0 1 1.414 0","key":"svg-0"}]]

/**
 * IconChevronDownFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY2hldnJvbi1kb3duIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOC43MDcgOC4yOTNhMSAxIDAgMCAxIDAgMS40MTRsLTYgNmExIDEgMCAwIDEgLTEuNDE0IDBsLTYgLTZhMSAxIDAgMCAxIDEuNDE0IC0xLjQxNGw1LjI5MyA1LjI5M2w1LjI5MyAtNS4yOTNhMSAxIDAgMCAxIDEuNDE0IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/chevron-down-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronDownFilled = createReactComponent('filled', 'chevron-down-filled', 'ChevronDownFilled', __iconNode);

export default IconChevronDownFilled;